import React, { Suspense } from "react";
import { UserData } from "../AppRoutes";
import { Navigate, Route, Routes } from "react-router-dom";

interface dtsProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const MainPage = React.lazy(() => import("../../pages/main-pages/MainPage"));

const Events = React.lazy(
  () => import("../../pages/main-pages/dts/events/list/EventList"),
);
const EventRequest = React.lazy(
  () =>
    import("../../pages/main-pages/dts/event-requests/list/EventRequestList"),
);
const WinnersList = React.lazy(
  () => import("../../pages/main-pages/dts/winners/list/WinnersList"),
);
const PreviousWinnersList = React.lazy(
  () =>
    import("../../pages/main-pages/dts/previous-winners/PreviousWinnersList"),
);
const Prizes = React.lazy(
  () => import("../../pages/main-pages/dts/prizes/list/PricesList"),
);
const Sponsor = React.lazy(
  () => import("../../pages/main-pages/dts/sponsor/list/SponsorList"),
);
const Teams = React.lazy(
  () => import("../../pages/main-pages/dts/team/list/TeamList"),
);
const EventCategory = React.lazy(
  () =>
    import("../../pages/main-pages/dts/event-category/list/EventCategoryList"),
);
const Reports = React.lazy(
  () => import("../../pages/main-pages/dts/reports/Reports"),
);

const DTSRoutes: React.FC<dtsProps> = ({ setIsAuthenticated }) => {
  return (
    <Suspense fallback={<div>...Loading</div>}>
      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          <Route index element={<Navigate to="events" replace />} />
          <Route path="events" element={<Events />} />
          <Route path="winners" element={<WinnersList />} />
          <Route path="previous-winners" element={<PreviousWinnersList />} />
          <Route path="event-requests" element={<EventRequest />} />
          <Route path="prizes" element={<Prizes />} />
          <Route path="sponsor" element={<Sponsor />} />
          <Route path="team" element={<Teams />} />
          <Route path="reports" element={<Reports />} />
          <Route path="event-category" element={<EventCategory />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default DTSRoutes;
